<script lang="ts">
	import type { OperationModel } from '@app/models/api/OperationModel';
	import { DonutChart } from '@wiseed/wikit';
	import { capitalize } from '@wiseed/wikit';
	import { t } from 'svelte-i18n';
	import { getChartsSharedOptions } from '@app/utils/charts';

	export let operation: OperationModel;

	let donutData = operation.fundUsages.map((e) => {
		return {
			group: `${e.description} (${e.percentage}%)`,
			value: e.percentage
		};
	});
</script>

{#if operation.fundUsages && operation.fundUsages.length}
	<section>
		<h2>{capitalize($t('operation.fundUsages'))}</h2>
		<DonutChart data={donutData} {getChartsSharedOptions} />
	</section>
{/if}
